interface HeaderWrapperProps {
    /**
     * Wrapper content
     */
    children?: JSX.Element | JSX.Element[]
    /**
     * Show header on webview
     */
    showOnWebview?: boolean
}

export const HeaderWrapper = ({ children, showOnWebview = true }: HeaderWrapperProps) => {
    if (!showOnWebview) {
        return <></>
    }

    return (
        <header className="web-header py-3 sm:py-5 pl-5 pr-4 sm:pr-6 bg-neutrals-light border-b border-neutrals-100 flex items-center min-h-header h-auto">
            {children}
        </header>
    )
}


